import React from 'react';
import axios from 'axios';
import { Alert, Spin } from 'antd';

import apiPath from 'apiPath';
import CsuId from 'images/csuid.png';

export default class CSU extends React.Component {
	state = {
		loaded: false,
		EID: null,
		ENAME: null
	}
	componentWillMount() {
		axios.get(apiPath + '/csuinfo', { withCredentials: true })
			.then(result => this.setState({
				loaded: true,
				EID: result.data.EID,
				ENAME: result.data.ENAME
			})).catch(error => {
				this.setState({ loaded: true });
				console.error(error);
			});
	}
	render() {
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'academic/EID');
			if (redirect) return redirect;
		}
		if (!this.state.loaded) return <Spin />;
		if (this.state.EID !== null || this.state.ENAME !== null) {
			return (
				<div>
					<Alert showIcon type="success"
						description={<span>
							Your CSU ID is <strong>{this.state.EID}</strong><br />
							Your CSU eName is <strong>{this.state.ENAME}</strong><br />
							<br />
							If any of this information is incorrect, please contact us.
					</span>} />
					<br/>
					<div>
						<p>You are now eligible to set up your Colorado State eID (electronic identification) -- your personal online identifier in the CSU portal, RAMweb. If you are currently a CSU studnet, your may skip this step and proceed directly to 'Registration Ready' in RAMweb using your existing eID.</p>
					<br />
					<p>Go Here:</p><a href="https://eid.colostate.edu/eIDCreate/login.aspx" target="blank">https://eid.colostate.edu/eIDCreate/login.aspx</a>
					<br />
					<br />
					<img src={CsuId} alt="CSU-Screenshot" className="image"/> 
					<br />
					<p>Please enter the following:</p>
					<ul style={{listStyleType: "disc", paddingLeft:"20px"}}>
						<li>CSU ID(as listed above)</li>
						<li>Last Name</li>
						<li>Date of Birth(mm/dd/yy)</li>
					</ul>
					<br />
					<p>Thereafter you will self-select a username and 15+ character password. Make note of your username and password. You will need these to access <a href="https://ramweb.colostate.edu/registrar/Public/Login.aspx" target="blank">RAMweb</a> and registration.</p>
					<br />
					<p>***Note, there sometimes is a 24 hour lag between the creation of the eID and it being recognized across the CSU systems. Please do not panic if you set up your eID and immediately try to access RAMweb without success.</p>
					</div>
				</div>
			)
		}
		return (
			<Alert showIcon type="info"
						description={<span>
							<h3>CSU EID's begin generating 5 weeks out from course registration.  If you are in this 5 week window, please allow 2-5 business days for your CSU EID to be generated.</h3>
					</span>} />
		);
	}
}



// WEBPACK FOOTER //
// ./portal-components/Portal/Academic/CSUEID.jsx